<template>
  <div class="bsp-general-wrap">
    <Tabs :value="tabValue" @on-click="(data) => { tabValue = data }">
      <TabPane label="审批" name="sp" v-if="showSp">
        <div class="bsp-approve" v-if="tabValue == 'sp'">
          <Form :label-width="120" label-colon class="form-ctnt" ref="approvalForm" label-position="right"
            :model="formValidate" :rules="ruleValidate">
            <FormItem :label="formLabel.approvalNode" required v-if="showApproveUser && nextNodeList.length > 0">
              <Select v-model="selectNode" filterable @on-change="onSelectNode" style="width: 100%" :transfer="true">
                <Option v-for="item in nextNodeList" :value="item.nodeId" :key="item.nodeId">{{ item.nodeName }}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="审批结果" required v-if="selectNode" prop="isApprove">
              <RadioGroup v-model="formValidate.isApprove" @on-change="isApproveChange">
                <Radio v-for="item in optionsBtnArr" :key="item.id" size="large" :label="item.code">{{ item.name }}
                </Radio>
              </RadioGroup>
            </FormItem>
            <FormItem :label="formLabel.approvalContent" prop="approvalContent" v-if="selectNode">
              <Input type="textarea" :autosize="{ minRows: 2 }" style="width:100%"
                v-model="formValidate.approvalContent" placeholder="请输入审批意见" />
            </FormItem>
            <FormItem :label="formLabel.approvalDate" prop="approvalDate" v-if="selectNode">
              <el-date-picker type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formValidate.approvalDate" style="width:100%;font-size: 16px;"></el-date-picker>
            </FormItem>
            <FormItem :label="formLabel.approvalOrg" v-if="showApproveUser && selectNode">
              <div class="uni-ctnt">
                <div class="uni-sel">
                  <Select class="sel" style="width:100%" v-model="selectOrgArr" filterable @on-select="orgSelectEvent"
                    :transfer="true">
                    <Option v-for="item in orgArr" :value="item.orgId" :key="item.orgId">{{ item.orgName }}</Option>
                  </Select>
                </div>
                <div class="checkAll">
                  <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">全选
                  </Checkbox>
                </div>
                <div class="uni-list">
                  <div style="float:left" v-for="orgItem in orgUserList" :key="orgItem.orgId">
                    <CheckboxGroup v-model="checkedUser" class="check" size="large" @on-change="checkAllGroupChange">
                      <Checkbox v-for="user in orgItem.user" :key="user.userIdCard + '_' + user.orgCode"
                        :label="user.userIdCard + '_' + user.orgCode">{{ user.userName }}</Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
              </div>
            </FormItem>

            <FormItem label="退回节点" required v-if="formValidate.isBack" prop="backNodeId">
              <Select v-model="formValidate.backNodeId" style="width: 100%;" :transfer="true">
                <Option v-for="item in rollbackNodeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>

            <FormItem label="被指派人" required v-if="formValidate.isDelegateTask" prop="delegateUserName">
              <div style="width: 100%">
                <user-selector v-model="formValidate.delegateUserId" :text.sync="formValidate.delegateUserName"
                  tit="选择被指派民警" numExp="num==1" msg="主办民警数量必须等于1人" @onSelect="selectDelegate"
                  @onClear="clearDelegate" />
              </div>
            </FormItem>

            <FormItem :label="customSlotName" v-if="showCustomSlot">
              <slot name="customSlot"></slot>
            </FormItem>

            <FormItem label="抄送" v-if="showcc && selectNode">
              <div style="background-color:#CEE0F0;text-align:left;width:100%;border: 1px solid #CEE0F0;">
                <div class="bsp-flow-people-ctnt scroll-able" style="padding:8px;background:#fff;display: flex">
                  <Tag style="display: flex;align-items: center;text-overflow: ellipsis;" v-for="(item, i) in csldList" :key="item.idcard"
                    @on-close="csld_close(i)" type="dot" closable color="primary">{{ item.name }}</Tag>
                  <user-selector ref="userSelector" tit="选择抄送人员" @onSelect="policeConfirm" :value="formValidate.csldbh">
                    <Button icon="md-add" class="bsp-sel-user" style="padding: 0 10px;margin-top: -1px;" type="dashed"
                      slot="func">添加人员</Button>
                  </user-selector>
                </div>
              </div>
            </FormItem>
          </Form>

          <div class="tip-container" v-if="!selectNode">
            <span class="tip-title">提示</span><span class="tip-warning">(请注意区分审核节点选择的选项)</span>
            <p>领导审批： 由单位内法制领导审批</p>
            <p>法制审批： 由单位内法制领导审批</p>
          </div>

          <div class="footer-approve">
            <Button @click="cancel" class="cancle-button" v-if="showBack">{{ cancelBtnText }}</Button>&nbsp;&nbsp;
            <Button class="submit-button" :disabled="disabledSubmit" type="primary" :loading="custom_loading"
              @click="handleSubmit('approvalForm')">{{ confirmBtnText }}</Button>
          </div>
        </div>
      </TabPane>
      <TabPane label="流程轨迹" name="flow">
        <div class="bsp-approve" v-if="tabValue == 'flow'">
          <s-general-history v-if="actInstId" :key="timer" :showModifyBtn="false" :actInstId="actInstId">
          </s-general-history>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import audit from "../mixins/audit-methods"
import sGeneralHistory from '../flow-general-history/components/flow-general-history.vue'


export default {
  components: {
    sGeneralHistory
  },
  mixins: [audit],
  data() {
    return {
      tabValue: 'sp',
      showSp: true,
      timer: new Date().getTime()
    }
  },
  watch: {
    delegationState: function (val) {
      if (val == "PENDING") {
        this.delegationName = "【委派】";
      } else {
        this.delegationName = "";
      }
    },
    isLastUserTask: function (val) {
      if (val) {
        this.formValidate.approvalContent = "同意"
      } else {
        this.formValidate.approvalContent = "同意上报"
      }
    }
  }
};
</script>

<style scoped>
.uni-ctnt {
  /* background-color: #f7fafe; */
  padding: 5px 0 20px 0;
}

.uni-sel {
  display: flex;
}

.uni-sel>.sel {
  width: 80%;
}

.uni-sel>.check {
  width: 20%;
  margin-left: 20px;
}

.uni-list {
  /* margin-top: 10px; */
  max-height: 100px;
  overflow: auto;
  width: 500px;
}

/deep/ .bsp-flow-modal .ivu-modal-header {
  padding: 0;
}

/deep/ .bsp-flow-modal .ivu-icon-ios-close {
  font-size: 32px;
}

/* 修改tag样式 */
/deep/ .bsp-flow-modal .ivu-tag-text {
  font-size: 16px;
}

/deep/ .bsp-flow-modal .ivu-tag-dot {
  padding: 0 8px;
}

/deep/ .bsp-flow-modal .ivu-tag-dot-inner {
  margin-right: 2px;
}

/deep/ .bsp-flow-modal .ivu-tag .ivu-icon-ios-close {
  font-size: 18px;
  top: 1px;
  margin-left: 4px !important;
}

/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ textarea.ivu-input {
  font-size: 16px;
}

/deep/ .bsp-flow-modal .bsp-sel-user .ivu-icon-md-add {
  font-size: 18px;
}

/deep/ .bsp-flow-modal .bsp-sel-user>.ivu-icon+span,
/deep/ .bsp-flow-modal .bsp-sel-user>span+.ivu-icon {
  margin-left: 0px;
  font-size: 16px;
}

/deep/ .ivu-select-input {
  font-size: 16px;
}

/deep/ .ivu-select-item {
  font-size: 16px !important;
}


/deep/ .ivu-checkbox-wrapper {
  font-size: 16px;
}

/deep/ .ivu-form-item {
  margin-bottom: 0px;
  padding-bottom: 10px;
}

/deep/ .ivu-modal-body {
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}

/deep/ .ivu-modal-footer {
  height: 50px;
  line-height: 50px;
  padding: 0px 12px;
}

.bsp-flow-modal .bsp-flow-modal-title {
  height: 40px;
  background: #2b5fda;
  width: 100%;
  text-indent: 1em;
  color: #fff;
  line-height: 40px;
  font-size: 15px;
}

.bsp-flow-modal .bsp-flow-people-ctnt {
  /* min-height: 56px; */
  /* max-height: 100px; */
  /* overflow: auto; */
}

.bsp-flow-people-ctnt>div {
  display: inline-block;
}

.bsp-flow-modal *::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.bsp-flow-modal *::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 3px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #c9c9c9;
}

.bsp-flow-modal *::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background: #ededed;
}

.cancle-button,
.submit-button {
  min-width: 60px;
  /* height:30px;
    line-height: 30px; */
  font-size: 14px;
  border-radius: 0;
}

.cancle-button {
  border: 1px solid #2B5FD9;
  color: #2B5FD9;
  background-color: #FFFFFF;
}

.submit-button {
  border: 1px solid #2B5FD9;
  color: #FFFFFF;
  background-color: #2B5FD9;
}

.tip-container {
  margin-top: 10px;
  background-color: #F2F6FC;
  padding: 16px;
}

.tip-container .tip-title {
  font-size: 16px;
  font-weight: bold;
  padding-right: 10px;
}

.tip-container .tip-warning {
  color: #E60012;
  font-weight: 16px;
}

.tip-container p {
  font-size: 16px;
  margin: 20px;
}

.bsp-approve {
  background: #FAFBFF;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #CEE0F0;
  padding: 16px 16px 2px 0;
  margin-top: 16px;
}

.footer-approve {
  text-align: center;
  margin: 0 16px 16px;
}

.bsp-general-wrap {
  width: 99%;
  font-family: "Noto Sans TC,  Microsoft YaHei,  Segoe UI, Tahoma,  Arial, Verdana,  sans-serif";

}

.bsp-general-wrap /deep/ .ivu-tabs-tab {
  font-size: 18px !important;
}

.bsp-general-wrap /deep/ .ivu-tabs-tab-active {
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/component/general-approve/components/flow-general-audit.vue